import {
  SUMMARY_UPLOAD_LINK_REQUEST,
  SUMMARY_UPLOAD_LINK_SUCCESS,
  SUMMARY_UPLOAD_LINK_ERROR,
} from "store/actions";

export function summaryUploadReducer(state, action) {
  switch (action.type) {
    case SUMMARY_UPLOAD_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SUMMARY_UPLOAD_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case SUMMARY_UPLOAD_LINK_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}

export default summaryUploadReducer;
